import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

import { ConfigService } from '../config.service';

@Component({
    host: { 'test-id': 'login-error' },
    selector: 'login-error',
    template: `
    <fw-layout-context
      title="Login Error"
      [description]="data"
      icon="warning-circle"
      iconColor="danger"
    >
      <fw-button (click)="retry()" variant="outline" leftIcon="rotate-refresh" size="large">{{'common.actions.retry' | translate}}</fw-button>
    </fw-layout-context>
  `,
    styles: [`
    :host {
      width: 100vw;
      height: 100vh;
      background: var(--page-light);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  `],
    standalone: false,
})
export class LoginErrorComponent {

  constructor(
    private auth0: Auth0Service,
    private config: ConfigService,
    private router: Router,
    private dialog: DialogRef<LoginErrorComponent>,
    @Inject(DIALOG_DATA) public data?: string,
  ){}

  retry(): void {
    if (!this.config.isAuth0Enabled()) {
      this.router.navigate(['/login']);
      this.dialog.close();
      return;
    }
    this.auth0.loginWithRedirect({ authorizationParams: { prompt: 'login' } })
  }
}
